import axios from 'axios'
import {ElLoading} from 'element-plus'
const service = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL, // api的base_url
  timeout: 1800000 // request timeout 1800000半个小时
})

// 拦截请求
service.interceptors.request.use(config => {
   ElLoading.service({ text: "正在执行操作...", background: 'rgba(0, 0, 0, 0.3)' });
   document.querySelector('.el-loading-mask').style.zIndex = '200000'; // 或其他高于弹框的 z-index 值
  if (localStorage.getItem('X-Token')) {
    //  存在将api_token写入 request header
    config.headers['zx-sid'] = localStorage.getItem('X-Token')
    config.headers['Content-Type'] = config.contentType || "application/json;charset=utf-8"
  }
  return config
},
  error => {
    // 显示调试错误信息
    console.log(error)
    // 显示错误信息;
    ElMessage({
      showClose: true,
      dangerouslyUseHTMLString: true,
      message: error,
      type: 'error',
      duration: 10000
    })
    Promise.reject(error)
  })

// 拦截返回
service.interceptors.response.use(
  response => {
     ElLoading.service().close();
    if (response.status === 200) {
      // 业务逻辑成功的返回结果
      return Promise.resolve(response.data)
    } else {
      // 业务逻辑不成功的返回
      ElMessage({
        showClose: true,
        dangerouslyUseHTMLString: true,
        message: response.data.msg,
        type: 'error',
        duration: 10000
      })
      return Promise.reject(response.data.msg)
    }
  },
  error => {
    ElLoading.service().close();
    if (error.code == 'ERR_NETWORK') {
      ElMessage({
        showClose: true,
        dangerouslyUseHTMLString: true,
        message: "网络不通，请检查网络",
        type: 'error',
        duration: 10000
      })
    }
    else {
      if (error.response.data.ErrorCode === 9003 || error.response.data.ErrorCode === 9004) {
        ElMessageBox.alert('登录超时！请重新登录。', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: () => {
            localStorage.clear();
            window.location.href = '/' // 回到登录页
          }
        })
      } else {
        ElMessage({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: error.response.data.Message,
          type: 'error',
          duration: 10000
        })
      }
    }
    return Promise.reject('')
  })

export default service
